/**
 * Проверяет, является ли URL корректным
 */
const isValidUrl = (url: string): boolean => {
  try {
    if (!/^https?:\/\//i.test(url)) return false;

    const parsed = new URL(url);
    const domainParts = parsed.hostname.split('.');

    if (domainParts.length < 2) {
      return false;
    }

    if (!domainParts.every((part) => part)) {
      return false;
    }

    const domainZone = domainParts[domainParts.length - 1];

    if (domainZone.length < 2) {
      return false;
    }
    return true;
  } catch {
    return false;
  }
};

/**
 * Проверяет, является ли ссылка безопасной
 */
function isSafeUrl(url: string): boolean {
  const dangerousPatterns = [/javascript:/i, /data:/i, /vbscript:/i, /file:/i, /mailto:/i, /tel:/i];

  return !dangerousPatterns.some((pattern) => pattern.test(url));
}

/**
 * Проверяет, является ли ссылка валидной и безопасной для отображения
 */
export function isLinkValid(url: string): boolean {
  return isValidUrl(url) && isSafeUrl(url);
}
